import React, { useState, useEffect, useContext } from 'react';
import ProjectsListCard from '/src/Components/ProjectsListCard/ProjectsListCard';
import ResourceCard from '/src/Components/ResourceCard/ResourceCard';
import './style.css';
import { AddressSearchContext, WindowSizeContext } from '/src/App';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';

const DIYGuidanceResources = ({
    projectsDIY,
    propertyData
}) => {

    // Get the portalData from the AddressSearchContext
    const { portalData } = useContext(AddressSearchContext);
    const { deviceType } = useContext(WindowSizeContext);
    const [resources, setResources] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);
    const [projectsDIYWithResources, setProjectsDIYWithResources] = useState([]);
    // console.log('projectsDIYWithResources ', projectsDIYWithResources);
    // console.log('selectedProject ', selectedProject);
    useEffect(() => {

        // Load the resources from local storage
        const loadedResources = portalData.resources;
        setResources(loadedResources);
    }, []);

    // Map through the projectsDIY, take the project_associated_resources array, and for each string, use that to filter the resources to find the matching id and replace the string with that resource object
    useEffect(() => {

        if (projectsDIY.length > 0 && resources.length > 0) {
            // console.log('projectsDIY and resources ', projectsDIY, resources);
            const projectsDIYWithResources = projectsDIY.map(project => {
                const projectAssociatedResources = project.project_associated_resources;
                const projectAssociatedResourcesWithResources = projectAssociatedResources.map(resourceId => {
                    const resource = resources.find(resource => resource.id === resourceId);
                    // console.log('resource ', resource, resourceId);
                    return resource;
                });
                return {
                    ...project,
                    project_associated_resources: projectAssociatedResourcesWithResources
                };
            });
            setProjectsDIYWithResources(projectsDIYWithResources);
        }
    }, [projectsDIY, resources]);

    useEffect(() => {
        if (projectsDIY.length > 0) {
            setSelectedProject(projectsDIY[0]);
        }
    }, [projectsDIY]);

    const handleProjectClick = (projectId) => {
        // Get the project from the projectsDIY array
        // console.log('projectsDIYWithResources ', projectsDIYWithResources);
        const project = projectsDIY.find(project => project.project_id === projectId);
        // console.log('project CLICKED', project);
        setSelectedProject(project);
    }

    const resoucesIntroSentence = "We've compiled a list of resources that can help you with your DIY projects. Click on a resource to learn more.";

    return (
        <div className="diy-projects-review-section-content">
            {/* <p className="diy-projects-review-section-resources-intro text-align-center" dangerouslySetInnerHTML={{ __html: resoucesIntroSentence }} /> */}
            <div className={`diy-projects-review-section-resources-container ${deviceType}`}>
                {projectsDIY.length > 0 && projectsDIY.map((project) => {

                    const hasAProjectBeenSelected = selectedProject !== null;
                    const isSelected = hasAProjectBeenSelected && selectedProject.project_id === project.project_id;
                    // console.log('project ', project);
                    return (
                        <div
                            key={project.project_id}
                            className={`diy-projects-review-section-resource-card ${hasAProjectBeenSelected ? isSelected ? 'selected' : 'not-selected' : ''}`}
                            onClick={() => handleProjectClick(project.project_id)}
                        >
                            <ProjectsListCard
                                project={project}
                                handleProjectClick={handleProjectClick}
                                showAllDetails={false}
                                simulatorView={false}
                            />
                        </div>
                    )
                })}
            </div>
            {selectedProject && (
                <>
                    <div className="horizontal-divider" />
                    <div className={`diy-projects-review-section-resource-card-resources-container ${deviceType}`}>
                        {(selectedProject.project_associated_resources && selectedProject.project_associated_resources.length > 0) && (
                            selectedProject.project_associated_resources.map((resource) => {

                                console.log('resource ', resource);
                                return (
                                    <ResourceCard
                                        resource={resource}
                                        key={resource.id}
                                        showTags={false}
                                    />
                                )
                            }
                            )
                        )
                        }
                    </div>
                </>
            )}
        </div>
    );
};

export default DIYGuidanceResources;